module.exports = __webpack_public_path__ + "img/Your-results.b5860486.svg";